<template>
  <v-app id="inspire">
    <v-content>
      <v-container class="pa-0">

        <v-alert
          v-model="alert"
          color="teal"
          icon="mdi-clock-fast"
          border="left"
          transition="scale-transition"
          text
          style="font-size:80%;"
        >
          2020/05/17 プログラムアップデートのお知らせ v0.6.1
          <br>・介護記録登録後に2時間以内であれば修正可能機能を追加
          <br>・介護記録入力に簡単入力ボタン追加 介護記録入力時に直近の実績データから同じパターンの入力を自動で行う機能です。(過去の実績パターンが増えれば増えるほど精度が高まります。)
        </v-alert>

        <v-alert
          dense
          type="info"
          text
          class="mb-0"
        >
          {{formatDate(calday)}}
        </v-alert>

        <v-row>
          <v-col cols="12">
            <v-card
              outlined

            >
              <v-card-title>
                <v-icon
                  large
                  left
                >
                  assignment
                </v-icon>
                <span class="title font-weight-light">{{this.$store.getters.auth.name}}さん担当シフト</span>
              </v-card-title>

              <v-card-subtitle>本日から今週分の担当シフト一覧です。</v-card-subtitle>

              <v-img
                  height="5"
                  src="@/assets/banner01.png"
                ></v-img>

              <v-card-text>
                <p
                 class="mb-0"
                 style="font-size:120%;color:black;"
                 v-for="v in items" 
                 v-bind:key="v.id"
                 >{{formatDate(v.date)}} {{v.riname}} {{v.kaisi}} - {{v.syuryo}}</p>

              </v-card-text>

              <v-img
                  height="5"
                  src="@/assets/banner01.png"
                ></v-img>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  outlined
                  @click="link('/month')"
                  color="success" 
                  >
                  <v-icon right>event</v-icon>
                  月間シフト
                </v-btn>
                <v-btn
                  outlined
                  @click="link('/kiroku')"
                  color="indigo" 
                  >
                  <v-icon right>create</v-icon>
                  実績＆テレッサ入力
                </v-btn>
              </v-card-actions>

            </v-card>
          </v-col>

        </v-row>

        <v-row>
          <v-col cols="12">
            <v-card
              outlined

            >
              <v-card-title>
                <v-icon
                  large
                  left
                >
                  perm_contact_calendar
                </v-icon>
                <span class="title font-weight-light">利用者様情報共有</span>
              </v-card-title>

              <v-card-subtitle>利用者様別のお知らせ</v-card-subtitle>


              <v-img
                  height="5"
                  src="@/assets/banner05.png"
                ></v-img>

              <v-card-text>
                プログラム実装中 近日公開
              </v-card-text>

              <v-img
                  height="5"
                  src="@/assets/banner05.png"
                ></v-img>


              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  outlined
                  color="orange" 
                  >
                  <v-icon right>create</v-icon>
                  利用者情報共有追加
                </v-btn>
              </v-card-actions>


            </v-card>
          </v-col>

        </v-row>

        <v-row>
          <v-col cols="12">
            <v-card
              outlined

            >
              <v-card-title>
                <v-icon
                  large
                  left
                >
                  business
                </v-icon>
                <span class="title font-weight-light">会社からのお知らせ</span>
              </v-card-title>

              <v-card-subtitle>会社からの通達、連絡事項など</v-card-subtitle>

              <v-img
                  height="5"
                  src="@/assets/banner13.png"
                ></v-img>

              <v-card-text>
                プログラム実装中近日公開
              </v-card-text>

              <v-img
                  height="5"
                  src="@/assets/banner13.png"
                ></v-img>


            </v-card>
          </v-col>

        </v-row>

    </v-container>
  </v-content>
</v-app>
</template>

<script>
import Common from '@/components/Common'
import moment from 'moment'
export default {
  mixins: [ Common ],
  data: () => ({
    items: [],
    calday: moment(),
    weather: [],
    alert: true

  }),
  created () {
    this.kousin()
  },

  mounted () {
  },

  methods: {
    link (item) {
      this.$router.push(item)
    },
    formatDate: function (date) {
      return moment(date).format('MM/DD (ddd)')
    },
    kousin () {
      var self = this
      this.$axios.post(this.url + 'shift.php', JSON.stringify({
        kaisi: moment(this.calday).format('YYYY-MM-DD'),
        syuryo: moment(this.calday).add(7, 'days').format('YYYY-MM-DD'),
        today: '',
        order: 'hiduke',
        id: this.$store.getters.auth.id,
        role: ''
      })).then(function (res) {
        self.items = res.data
      })
    },

  }

}
</script>
